<template>
  <div class="md:mx-8 lg:container lg:relative mx-3 my-12">
    <h2 v-if="mainHeading" class="fluid-xl leading-tight font-medium my-5" data-test-id="main-heading">
      {{ mainHeading }}
    </h2>

    <slot></slot>

    <div class="lg:absolute flex inset-0 w-full lg:p-8" :class="[alignmentClasses]">
      <div
        class="bg-blackly py-10 lg:w-2/5 lg:px-10 xl:px-14 xl:pt-20 xl:pb-24 px-5 pt-10 text-white flex flex-col items-start justify-center w-full"
      >
        <h2 v-if="heading" class="fluid-3xl leading-none" v-html="heading"></h2>
        <div
          v-if="teaser"
          class="fluid-base leading-relaxed font-light md:pb-2 lg:py-5 pt-4 pb-1"
          v-html="teaser"
        ></div>
        <ProductComparePriceByHandle
          v-if="productHandle"
          :handle="productHandle"
          price-class="fluid-xl leading-tight font-medium h-10"
          compare-price-class="fluid-lg leading-tight font-medium"
        />
        <LinkField v-if="cta[0] && cta[0].text" v-bind="cta[0]" class="btn-pill-black mt-5" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ProductComparePriceByHandle from '@/components/common/ProductComparePriceByHandle';
import LinkField from '@/components/common/LinkField';

const props = defineProps({
  mainHeading: {
    type: String,
    default: null,
  },
  heading: {
    type: String,
    default: null,
  },
  teaser: {
    type: String,
    default: null,
  },
  cta: {
    type: Array,
    default: () => [],
  },
  boxPosition: {
    type: String,
    default: 'middleRight',
  },
  productHandle: {
    type: String,
    default: null,
  },
});

const alignmentClasses = computed(() => {
  const position = props.boxPosition?.toLowerCase();

  if (!position) {
    return 'items-end justify-start';
  }

  let vertical = 'items-end';
  if (position.includes('top')) {
    vertical = 'items-end md:items-start';
  } else if (position.includes('middle')) {
    vertical = 'items-end md:items-center';
  } else if (position === 'center') {
    vertical = 'items-end md:items-center';
  }

  let horizontal = 'justify-start';

  if (position.includes('right') || position === 'middleRight') {
    horizontal = 'justify-end';
  } else if (position === 'center') {
    horizontal = 'justify-center';
  }

  return `${vertical} ${horizontal}`;
});
</script>
